import { render } from "./ContainersExample.vue?vue&type=template&id=1b5c17fe&scoped=true"
import script from "./ContainersExample.vue?vue&type=script&lang=js"
export * from "./ContainersExample.vue?vue&type=script&lang=js"

import "./ContainersExample.vue?vue&type=style&index=0&id=1b5c17fe&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5c17fe"]])

export default __exports__